import useReveal from "../../hooks/useReveal";

export default function SectionTitle({ eyebrow, title, align = "left", className = "" }) {
  const ref = useReveal();
  const isCenter = align === "center";

  return (
    <div
      ref={ref}
      className={`reveal mb-8 ${isCenter ? "text-center" : "text-left"} ${className}`}
    >
      <div className={`mb-3 flex items-center gap-4 ${isCenter ? "justify-center" : ""}`}>
        {isCenter && <span className="h-px w-12 bg-white/30 sm:w-24" aria-hidden="true" />}
        <span className="eyebrow whitespace-nowrap">{eyebrow}</span>
        <span className="h-px w-12 bg-white/30 sm:w-24" aria-hidden="true" />
      </div>
      <h2 className="text-balance border-b border-white/15 pb-5 text-3xl font-bold text-white sm:text-4xl lg:text-[2.75rem]">
        {title}
      </h2>
    </div>
  );
}
